<template>
  <div v-loading="$store.state.pageLoading">
    <el-container class="homeContainer">
      <div class="collapseAside" @click="collapseASide = !collapseASide"><i class="collapseIcon" :class="collapseASide ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i></div>
      <el-header height="70px" style="background-color:#2c3e50">
        <HomeHeader />
      </el-header>
      <el-aside>
        <HomeAside ref="aside"/>
      </el-aside>
      <div ref="homeMain" class="homeMain">
        <transition name="el-fade-in-linear" mode="out-in">
          <keep-alive include="materialList,productList">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </el-container>
    <el-backtop target=".homeMain"></el-backtop>
  </div>
</template>

<script>
import HomeAside from '../components/HomeAside'
import HomeHeader from '../components/HomeHeader'
export default {
  components: {
    HomeHeader,
    HomeAside
  },
  data () {
    return {
      collapseASide: true
    }
  },
  watch: {
    collapseASide: {
      handler: function (value) {
        if (value) {
          this.$refs['aside'].$el.style.width = '55px'
          this.$refs['homeMain'].style.left = '55px'
        } else {
          this.$refs['aside'].$el.style.width = '220px'
          this.$refs['homeMain'].style.left = '220px'
        }
      }
    },
    immediate: true
  },
  mounted () {
    window.vm = this.$refs['aside']
    this.$store.dispatch('getLoginInfo')
  }
}
</script>

<style scoped>
.homeContainer {
  font-family: Helvetica Neue, Helvetica, microsoft yahei, arial, STHeiTi,
    sans-serif;
}
.homeMain {
  position: absolute;
  left: 55px;
  right: 0;
  top: 70px;
  bottom: 0;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: scroll;
}
.collapseAside{
  top: 0;
  box-sizing: border-box;
  height: 70px;
  width: 20px;
  background-color: #ffffff;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
